













































import { Component, Mixins } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import { LOADING_GLOBAL_KEY } from '@/constants/loading-constants';
import { getModule } from 'vuex-module-decorators';
import { LoadingStore } from '@/store/loading-store';
import { AuthStore } from '@/store/auth-store';
import store from '@/store';
import { StaffRepository } from '@/staff/repositories/staff-repository';

const loadingState = getModule(LoadingStore);
const authState = getModule(AuthStore, store);
const staffRepository = new StaffRepository();

@Component
export default class SetRecoveryEmail extends Mixins(LocaleMixin) {
    private recoveryEmail = '';
    private validForm = false;
    private notEmpty = [
        (v: string) => !!v || 'Please enter a value'
    ];

    public async setRecoveryEmail() {
        loadingState.loadingIncrement(LOADING_GLOBAL_KEY);
        const updatePayload = {
            id: authState.id!,
            recovery_email: this.recoveryEmail
        };
        try {
            await staffRepository.update(updatePayload);
            const userInfo = await staffRepository.getOne(authState.id!);
            authState.storeUserInfo(userInfo);
            this.$router.push('/');
            loadingState.loadingStop(LOADING_GLOBAL_KEY);
        } catch (error) {
            loadingState.loadingStop(LOADING_GLOBAL_KEY);
            this.$swal({ text: 'Please make sure you entered a valid email and that nobody else is using it', icon: 'error' });
        }
    }
}
